import React from "react";
import { Brain, Users, Lightbulb, Award, Cpu, Trophy } from "lucide-react";

const WhySection = () => {
  const cards = [
    {
      title: "AI & Robotics Learning",
      description: "Students explore Artificial Intelligence, Robotics, Automation and emerging technologies through fun and engaging projects.",
      delay: "delay-100",
      iconBg: "rgba(168, 85, 247, 0.1)",
      iconColor: "var(--accent-purple)",
      icon: <Brain />
    },
    {
      title: "Hands-On Projects",
      description: "Every course includes practical projects that help students apply concepts in real-world scenarios.",
      delay: "delay-200",
      iconBg: "rgba(249, 115, 22, 0.1)",
      iconColor: "var(--accent-orange)",
      icon: <Lightbulb />
    },
    {
      title: "Industry-Relevant Skills",
      description: "Learn future-ready skills including coding, AI, robotics, design thinking, content creation and digital literacy.",
      delay: "delay-300",
      iconBg: "rgba(14, 165, 233, 0.1)",
      iconColor: "var(--accent-blue)",
      icon: <Cpu />
    },
    {
      title: "Expert Mentors",
      description: "Learn from experienced instructors who make complex concepts simple and engaging for every age group.",
      delay: "delay-100",
      iconBg: "rgba(16, 185, 129, 0.1)",
      iconColor: "var(--accent-green)",
      icon: <Users />
    },
    {
      title: "Competitions & Challenges",
      description: "Participate in robotics challenges, coding contests, Olympiads and innovation events throughout the year.",
      delay: "delay-200",
      iconBg: "rgba(236, 72, 153, 0.1)",
      iconColor: "var(--accent-pink)",
      icon: <Trophy />
    },
    {
      title: "Certifications & Portfolio",
      description: "Students build project portfolios and earn certificates that showcase their skills and achievements.",
      delay: "delay-300",
      iconBg: "rgba(139, 92, 246, 0.1)",
      iconColor: "var(--accent-purple)",
      icon: <Award />
    }
  ];

  return (
    <section className="section why section-white" id="why">
      <div className="container">
        <div className="section-header reveal-triggered fade-up active">
          <h2>Why Parents Choose <span className="text-gradient">Practido Learning Center</span></h2>
          <p>The most complete AI and coding education platform for young innovators - designed to build 21st-century skills through live classes, real projects and expert mentors.</p>
        </div>

        <div className="why-grid">
          {cards.map((card, index) => (
            <div key={index} className={`premium-card why-card reveal-triggered fade-up ${card.delay} active`}>
              <div className="icon-box" style={{ backgroundColor: card.iconBg, color: card.iconColor }}>
                {card.icon}
              </div>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhySection;
